import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cont" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createTextVNode(" Got limit of data? Try using your github access token! ")),
      _cache[2] || (_cache[2] = _createElementVNode("i", null, "(Optional)", -1)),
      _createTextVNode(" " + _toDisplayString(this.$store.getters.getToken), 1)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("a", { href: "https://github.com/settings/tokens/new" }, "Create your token here", -1)),
    _withDirectives(_createElementVNode("input", {
      placeholder: "example - ghp_bx21v37c...",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.token) = $event))
    }, null, 512), [
      [_vModelText, _ctx.token]
    ])
  ]))
}